<template>
  <AdminLayout v-model:activeTab="view">
    <div v-if="view === 'reporte_produccion'"><ReporteProduccion /></div>
    <div v-else-if="view === 'reporte_almacen'"><ReporteAlmacen /></div>
  </AdminLayout>
</template>

<script setup>
import { ref } from "vue";
import AdminLayout from "@/components/Layout/AdminLayout.vue";
import ReporteProduccion from "@/components/Inyeccion/ReporteProduccion.vue";
import ReporteAlmacen from "@/components/Inyeccion/ReporteAlmacen.vue";
import { useAuthStore } from "@/store/useAuthStore";

// El menú ahora trae dos tabs dentro de "Inyección" (ver navigation.js):
// Nico (responsable_inyeccion) solo ve "reporte_produccion", Brenda
// (responsable_almacen) solo ve "reporte_almacen", y superadmin/
// business_owner ven ambos y pueden moverse libremente entre los dos.
const authStore = useAuthStore();
const view = ref(
  authStore.role === "responsable_almacen" ? "reporte_almacen" : "reporte_produccion"
);
</script>
